var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoritesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8593 3.76752C23.4725 0.919863 18.2401 1.3476 14.9999 4.64643C11.7597 1.3476 6.52723 0.914004 3.14051 3.76752C-1.26574 7.4765 -0.621209 13.5234 2.51942 16.7285L12.7968 27.1992C13.3827 27.7968 14.1679 28.1308 14.9999 28.1308C15.8378 28.1308 16.6171 27.8027 17.203 27.205L27.4804 16.7343C30.6151 13.5292 31.2714 7.48236 26.8593 3.76752ZM25.4764 14.7538L15.1991 25.2246C15.0585 25.3652 14.9413 25.3652 14.8007 25.2246L4.52332 14.7538C2.38465 12.5742 1.95106 8.44916 4.95106 5.92377C7.23035 4.00775 10.746 4.29486 12.9491 6.539L14.9999 8.6308L17.0507 6.539C19.2655 4.28314 22.7811 4.00775 25.0487 5.91791C28.0429 8.4433 27.5975 12.5917 25.4764 14.7538Z",
    fill: "#C6C6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritesIcon);
export default __webpack_public_path__ + "static/media/favorites-icon.c7803d6f06cd61c6874c4c253aef8c8a.svg";
export { ForwardRef as ReactComponent };